import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum.js';
import JsxHelper from '../Helpers/JsxHelper.js';
import TpClientInvoiceItem from './TpClientInvoiceItem.js';

export default class OutstandingTpClientInvoiceItem extends TpClientInvoiceItem {
  static FieldsToShowInDataTable() {
    return [
      {
        label: OutstandingTpClientInvoiceItem.getSelectedCellHeader,
        orderById: '',
        data: OutstandingTpClientInvoiceItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      {
        label: 'Bare Invoice #',
        orderById: 'TpClientInvoiceId',
        data: TpClientInvoiceItem.GetDetailCellContent,
        minWidth: 20,
      },
      {
        label: 'Client Name (Caspian Client ID)',
        orderById: 'CaspianClientName',
        data: TpClientInvoiceItem.getCaspianClientNameCellContent,
        minWidth: 50,
      },
      {
        label: 'Bill To Contact',
        orderById: 'CiBillToContact',
        data: TpClientInvoiceItem.getBillToContactCellContent,
        minWidth: 40,
      },
      { label: 'Office', orderById: 'OfficeName', data: 'OfficeName', minWidth: 25 },
      { label: 'PO #', orderById: 'Ponumber', data: TpClientInvoiceItem.getPoNumberCellContent, minWidth: 20 },
      {
        label: 'Client Invoice #',
        orderById: 'InvoiceNumber',
        data: TpClientInvoiceItem.getInvoiceNumberCellContent,
        minWidth: 20,
      },
      {
        label: 'Internal Reference',
        orderById: 'InternalReferenceNumber',
        data: TpClientInvoiceItem.getInternalReferenceCellContent,
        minWidth: 30,
      },
      { label: 'Invoiced On', orderById: 'FinalizedOnUtc', data: 'FinalizedOnUtc', minWidth: 20 },
      { label: 'Due Date', orderById: 'InvoiceDueOnUtc', data: 'InvoiceDueOnUtc', minWidth: 20 },
      {
        label: 'Status',
        orderById: 'Status',
        data: 'Status',
        minWidth: 20,
      },
      { label: 'Invoice Line #', orderById: 'Count', data: 'Count', minWidth: 10 },
      {
        label: 'Has Prepay',
        orderById: 'HasPrepayLines',
        data: (item) => JsxHelper.YesNo(item.HasPrepayLines),
        minWidth: 10,
      },
      { label: 'Total', orderById: 'Total', data: 'Total', minWidth: 20 },
      { label: 'Applied Amount', orderById: 'Paid', data: 'Paid', minWidth: 20 },
      { label: 'Current Due', orderById: 'CurrentTotalDue', data: 'CurrentTotalDue', minWidth: 20 },
      { label: 'YRMO', orderById: 'Yrmo', data: 'Yrmo', minWidth: 10 },
    ];
  }

  static getSelectedCellHeader(item) {
    return (
      <input
        type='checkbox'
        checked={OutstandingTpClientInvoiceItem.selectedStatus()}
        onChange={(e) => {
          OutstandingTpClientInvoiceItem.clickOnGlobalSelect(item, e.target.checked);
        }}
      />
    );
  }

  static getSelectedCellContent(item) {
    return (
      <input
        type='checkbox'
        checked={item.Selected}
        onChange={(e) => {
          OutstandingTpClientInvoiceItem.clickOnSelect(item, e.target.checked);
        }}
      />
    );
  }

  static selectedStatus() {
    return false;
  }

  static clickOnGlobalSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static clickOnSelect(item, selected) {
    // Placeholder, don't remove it!
  }
}
